"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Collection_1 = require("../Collection");
const QuestionTypes_1 = require("../../Enum/QuestionTypes");
class Questionnaire {
    constructor() {
        this.questions = new Collection_1.default();
    }
    getId() {
        return this.id;
    }
    setId(id) {
        this.id = id;
        return this;
    }
    getMachineName() {
        return this.machineName;
    }
    setMachineName(machineName) {
        this.machineName = machineName;
        return this;
    }
    getTitle() {
        return this.title;
    }
    setTitle(title) {
        this.title = title;
        return this;
    }
    getDescription() {
        return this.description;
    }
    setDescription(description) {
        this.description = description;
        return this;
    }
    getQuestions() {
        return this.questions;
    }
    getQuestion(id) {
        return this.questions.find((question) => question.getId() === id);
    }
    setQuestions(questions) {
        this.questions = questions;
        return this;
    }
    hasAnyInput() {
        let hasAny = false;
        this.getQuestions().forEach((question) => {
            if (question.getType() === QuestionTypes_1.QuestionTypes.TEXT) {
                hasAny = true;
            }
            else if (question.getPossibleAnswers().count()) {
                hasAny = true;
            }
        });
        return hasAny;
    }
}
exports.default = Questionnaire;
